import type { RouteRecordRaw } from "vue-router"
import ProveRoutes from "./prove/prove-routes.ts"
import { useSessionStore } from "@versatile-credit-apply/sdk"
import { buildApplyStageRoutePath } from "@versatile-credit-apply/composition"
import { FlowExtension } from "@versatile-credit-apply/omni-apply-client"

const preProviderFeatureRoute: RouteRecordRaw = {
  path: "pre-provider",
  children: [
    {
      path: "",
      redirect: (to) => {
        console.log("Checking pre provider route")
        const sessionStore = useSessionStore()

        const extensions =
          sessionStore.findExtensionsByFlowPosition("pre_provider")

        if (extensions.length) {
          return to.fullPath.replace(
            "pre-provider",
            extensions[0]?.featureId as string
          )
        }

        // Go to application if no
        return buildApplyStageRoutePath(
          to.params.providerKey as string,
          "/workflows/pre-application",
          { params: to.params }
        )
      },
    },
  ],
}

const preApplicationFeatureRoute: RouteRecordRaw = {
  path: "pre-application",
  children: [
    {
      path: "",
      redirect: (to) => {
        console.log("Checking pre application route")
        const sessionStore = useSessionStore()

        const extensions =
          sessionStore.findExtensionsByFlowPosition("pre_application")

        if (extensions.length) {
          return to.fullPath.replace(
            "pre-application",
            extensions[0]?.featureId as string
          )
        }

        // No pre application extensions to run, go to the application
        return buildApplyStageRoutePath(
          to.params.providerKey as string,
          "/forms/application",
          { params: to.params }
        )
      },
    },
  ],
}

const featureFlowRoute: RouteRecordRaw = {
  path: ":id/next",
  redirect: (to) => {
    const sessionStore = useSessionStore()

    const id = to.params.id as FlowExtension["featureId"]

    const extension = sessionStore.findExtensionById(id)

    if (!extension) {
      throw new Error(`Unable to find extension with id=${id}`)
    }

    if (!extension.flowPosition) {
      throw new Error(`Extension is not routable id=${id}`)
    }

    const extensions = sessionStore.findExtensionsByFlowPosition(
      extension.flowPosition
    )

    const nextExtensions = extensions.slice(
      extensions.findIndex((other) => other.featureId === extension.featureId) +
        1
    )

    if (nextExtensions.length) {
      return `/apply/workflows/${nextExtensions[0]?.featureId}`
    }

    if (extension.flowPosition === "pre_provider") {
      return buildApplyStageRoutePath(to.params.providerKey as string, "/intro")
    }

    // Go to the application
    return buildApplyStageRoutePath(
      to.params.providerKey as string,
      "/forms/application",
      { params: to.params }
    )
  },
}

const WorkflowRoutes: RouteRecordRaw[] = [
  {
    path: "",
    children: [
      preProviderFeatureRoute,
      preApplicationFeatureRoute,
      featureFlowRoute,
      ...ProveRoutes,
    ],
  },
]

export default WorkflowRoutes
